export const getErrorMessage = (err) => {
  if (err?.status === 500) {
    return 'Terjadi kesalahan, silahkan coba lagi nanti atau hubungi admin TOMAZZ'
  }
  return err?.response?.data?.errors?.[0]?.message || ''
}
